"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./components/Label/index'));

//# sourceMappingURL=Label.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./Label.js
 ** module id = 76
 ** module chunks = 0
 **/